import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CampanhaStatusModule } from '../../status';
import { CampanhaEnviarAnaliseFormModalModule } from '../../analise/enviar-analise-form-modal';
import { CampanhaTableComponent } from './campanha-table.component';
import { CampanhaVisualizarModalModule } from '../../visualizar-modal';

@NgModule({
    imports: [
        SharedModule,
        CampanhaStatusModule,
        CampanhaEnviarAnaliseFormModalModule,
        CampanhaVisualizarModalModule
    ],
    declarations: [
        CampanhaTableComponent
    ],
    exports: [
        CampanhaTableComponent
    ]
})
export class CampanhaTableModule { }
